class FacetFiltersForm extends HTMLElement {
  static get defaultAvailabilityParam() {
    return ['filter.v.availability', '1'];
  }

  static normalizeTargetUrl(target) {
    if (typeof target === 'object' && target !== null) {
      return {
        pathname: target.pathname || window.location.pathname,
        searchParams: FacetFiltersForm.normalizeSearchParams(target.searchParams || ''),
      };
    }

    return {
      pathname: window.location.pathname,
      searchParams: FacetFiltersForm.normalizeSearchParams(target || ''),
    };
  }

  static stripPageParam(searchParams) {
    const params = new URLSearchParams(searchParams || '');
    params.delete('page');
    return params.toString();
  }

  static get categoryParamName() {
    return 'filter.p.t.category';
  }

  static get categoryTagGroupId() {
    return 'category';
  }

  static isCategoryInput(input) {
    return input.name === FacetFiltersForm.categoryParamName ||
      input.dataset.customTagGroupId === FacetFiltersForm.categoryTagGroupId;
  }

  static clearOtherCategoryInputs(activeInput) {
    if (!activeInput.checked || !FacetFiltersForm.isCategoryInput(activeInput)) return;

    document
      .querySelectorAll(`input[name="${FacetFiltersForm.categoryParamName}"], .js-custom-tag-filter[data-custom-tag-group-id="${FacetFiltersForm.categoryTagGroupId}"]`)
      .forEach((input) => {
        if (input !== activeInput) input.checked = false;
      });
  }

  static removeCategoryParams(searchParams) {
    const params = new URLSearchParams(searchParams || '');
    params.delete(FacetFiltersForm.categoryParamName);
    return params.toString();
  }

  static removeCustomTagFromPath(pathname, tagHandle) {
    const pathParts = (pathname || window.location.pathname).split('/');
    const lastPart = pathParts[pathParts.length - 1];

    if (!lastPart || !lastPart.includes(tagHandle)) return pathname || window.location.pathname;

    const activeTags = lastPart.split('+').filter((handle) => handle !== tagHandle);

    if (activeTags.length) {
      pathParts[pathParts.length - 1] = activeTags.join('+');
    } else {
      pathParts.pop();
    }

    return pathParts.join('/') || '/';
  }

  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    //const facetTiggers = this.querySelectorAll('.facets__button-show,.facets__container__overlay');
    //if (facetTiggers.length > 0) {
		//	facetTiggers.forEach(trigger => {
		//		trigger.addEventListener('click',()=> {
		//			this.querySelector('.facets__container').classList.toggle('active');
		//			this.querySelector('.facets__container__overlay').classList.toggle('active');
		//			document.body.classList.toggle('overflow-hidden');
		//		});
		//	})
    //}
		this.bindFacetTriggers();

    document.addEventListener('click', (e) => {
      const detailsList = document.querySelectorAll('.facets__wrapper--horizontal .facets__disclosure');
      const details = e.target.closest(".facets__disclosure[open]");

      if (!details && detailsList) {
        detailsList.forEach((item) => {
          item.removeAttribute("open");
        })
      }
    })

		
  }

	bindFacetTriggers() {
    const facetTriggerShow = this.querySelector(
			'.facets__button-show'
		);
		const facetTriggersClose = this.querySelectorAll(
			'.facets__container__overlay, .close-drawer',
		);
    if (facetTriggerShow) {
      facetTriggerShow.addEventListener('click', () => {
        this.querySelector('.facets__container').classList.add('active');
        this.querySelector('.facets__container__overlay').classList.add('active');
        document.body.classList.add('overflow-hidden');
      });
    } 
    
    if (facetTriggersClose.length > 0) {
			facetTriggersClose.forEach((trigger) => {
				trigger.addEventListener('click', () => {
					this.querySelector('.facets__container').classList.remove('active');
					this.querySelector('.facets__container__overlay').classList.remove(
						'active',
					);
					document.body.classList.remove('overflow-hidden');
				});
			});
		}
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const target = FacetFiltersForm.normalizeTargetUrl(
        event.state || { pathname: FacetFiltersForm.pathnameInitial, searchParams: FacetFiltersForm.searchParamsInitial }
      );
      const targetKey = `${target.pathname}?${target.searchParams}`;
      if (targetKey === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(target, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    const target = FacetFiltersForm.normalizeTargetUrl(searchParams);
    FacetFiltersForm.searchParamsPrev = `${target.pathname}?${target.searchParams}`;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${target.pathname}?section_id=${section.section}&${target.searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

		document.querySelector('facet-filters-form').bindFacetTriggers();

    if (updateURLHash) FacetFiltersForm.updateURLHash(target);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    if (document.querySelector('.js-load-more') || document.querySelector('.js-infinite-scroll')) 
      loadMore();
    
    colorSwatches();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const activeFilter = event ? event.target.closest('.js-filter') : undefined;
    const matchesIndex = (element) => {
      return activeFilter ? element.dataset.index === activeFilter.dataset.index : false;
    }
    const shouldFullyRerenderActiveFilter =
      activeFilter &&
      (
        activeFilter.dataset.index.startsWith('custom-tags-') ||
        activeFilter.dataset.index.startsWith('mobile-custom-tags-')
      );
    const facetsToRender = Array.from(facetDetailsElements).filter(
      element => shouldFullyRerenderActiveFilter || !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
		document.querySelector('facet-filters-form').bindFacetTriggers();
    if (countsToRender && !shouldFullyRerenderActiveFilter) FacetFiltersForm.renderCounts(countsToRender, activeFilter);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting','.facets__selected'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(target) {
    history.pushState(target, '', `${target.pathname}${target.searchParams && '?'.concat(target.searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return FacetFiltersForm.normalizeSearchParams(new URLSearchParams(formData).toString());
  }

  static hasDefaultAvailabilityFilter() {
    return Boolean(document.querySelector('[data-default-availability-filter="true"]'));
  }

  static normalizeSearchParams(searchParams) {
    if (!FacetFiltersForm.hasDefaultAvailabilityFilter()) return searchParams || '';

    const params = new URLSearchParams(searchParams || '');
    const [key, value] = FacetFiltersForm.defaultAvailabilityParam;

    if (params.get(key) !== value) {
      params.set(key, value);
    }

    return params.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    FacetFiltersForm.clearOtherCategoryInputs(event.target);

    if (event.target.dataset.customTagUrl) {
      const selectedCustomTags = new Map();
      const customTagInputs = document.querySelectorAll('.js-custom-tag-filter');

      customTagInputs.forEach((input) => {
        if (!input.checked) return;
        if (!input.dataset.customTagGroupId || !input.dataset.customTagHandle) return;
        selectedCustomTags.set(input.dataset.customTagGroupId, input.dataset.customTagHandle);
      });

      if (event.target.dataset.customTagGroupId) {
        if (event.target.checked && event.target.dataset.customTagHandle) {
          selectedCustomTags.set(event.target.dataset.customTagGroupId, event.target.dataset.customTagHandle);
        } else {
          selectedCustomTags.delete(event.target.dataset.customTagGroupId);
        }
      }

      const basePath = event.target.dataset.customTagBaseUrl || window.location.pathname;
      const tagPath = Array.from(selectedCustomTags.values()).join('+');
      const pathname = tagPath ? `${basePath}/${tagPath}` : basePath;
      let searchParams = FacetFiltersForm.stripPageParam(window.location.search.slice(1));

      if (event.target.dataset.customTagGroupId === FacetFiltersForm.categoryTagGroupId) {
        searchParams = FacetFiltersForm.removeCategoryParams(searchParams);
      }

      this.onSubmitForm({ pathname, searchParams }, event);
      return;
    }

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      const target = event.target.name === FacetFiltersForm.categoryParamName && event.target.checked
        ? {
          pathname: FacetFiltersForm.removeCustomTagFromPath(window.location.pathname, 'strand'),
          searchParams,
        }
        : searchParams;
      this.onSubmitForm(target, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      const searchParams = forms.join('&');
      const target = event.target.name === FacetFiltersForm.categoryParamName && event.target.checked
        ? {
          pathname: FacetFiltersForm.removeCustomTagFromPath(window.location.pathname, 'strand'),
          searchParams,
        }
        : searchParams;
      this.onSubmitForm(target, event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const targetUrl = new URL(event.currentTarget.href, window.location.origin);
    const preserveSearch = event.currentTarget.dataset.preserveSearch === 'true';
    const searchParams = preserveSearch
      ? FacetFiltersForm.stripPageParam(window.location.search.slice(1))
      : targetUrl.search.slice(1);

    FacetFiltersForm.renderPage({
      pathname: targetUrl.pathname,
      searchParams,
    });
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.pathnameInitial = window.location.pathname;
FacetFiltersForm.searchParamsInitial = FacetFiltersForm.normalizeSearchParams(window.location.search.slice(1));
FacetFiltersForm.searchParamsPrev = `${window.location.pathname}?${FacetFiltersForm.searchParamsInitial}`;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
    this.controlSlider();
    this.controlInput();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  fillSlider () {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    inputRangeWrappers.forEach(inputWrapper => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];

      const range = inputRangeTo.max - inputRangeTo.min;
      const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
      const toCurrent = inputRangeTo.value - inputRangeTo.min;
      const minRange = fromCurrent / range * 100;
      const maxRange = toCurrent / range * 100;

      inputWrapper.setAttribute(
        'style',
        `--range-min: ${minRange}%; --range-max: ${maxRange}%`
      );
    })
  }

  controlSlider () {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

    inputRangeWrappers.forEach((inputWrapper, index) => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];
      const inputNumberFrom = inputNumberWrappers[index].querySelectorAll('.field__input')[0];
      const inputNumberTo = inputNumberWrappers[index].querySelectorAll('.field__input')[1];

      inputRangeFrom.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        }
        else {
          inputNumberFrom.value = from;
        }

        this.fillSlider();
      }

      if (Number(inputRangeTo.value) <= 0 ) {
        inputRangeTo.style.zIndex = 2;
      } else {
        inputRangeTo.style.zIndex = 0;
      }

      inputRangeTo.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        }
        else {
          inputNumberTo.value = from;
          inputRangeTo.value = from;
        }

        if (Number(inputRangeTo.value) <= 0 ) {
          inputRangeTo.style.zIndex = 2;
        } else {
          inputRangeTo.style.zIndex = 0;
        }

        this.fillSlider();
      }
    })
  }

  controlInput() {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

    inputNumberWrappers.forEach((inputWrapper, index) => {
      const inputsNumber = inputWrapper.querySelectorAll('.field__input');
      const inputNumberFrom = inputsNumber[0];
      const inputNumberTo = inputsNumber[1];
      const inputRangeFrom = inputRangeWrappers[index].querySelectorAll('.field__range')[0];
      const inputRangeTo = inputRangeWrappers[index].querySelectorAll('.field__range')[1];

      inputNumberFrom.oninput = () => {
        const from = parseInt(inputNumberFrom.value, 10);
        const to = parseInt(inputNumberTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        } 
        else {
          inputRangeFrom.value = from;
        }

        this.fillSlider();
      }

      inputNumberTo.oninput = () => {
        const from = parseInt(inputNumberFrom.value, 10);
        const to = parseInt(inputNumberTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        }
        else {
          inputNumberTo.value = from;
        }

        this.fillSlider();
      }

    })
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
